import React from 'react'
import {Card, SelectField, Table, View, LinkAction, TableColumn} from 'react-template'
import { buscarTodosFormulariosComInscricaoPorCpf, buscarForms } from './actions/InternalActions'
import { formatLongToDate } from '../../helpers/Data';
import SubscriptionView from '../../components/view/SubscriptionView'

export default class ListInternalSubscriptions extends View {

    constructor(props){
        super(props)
        this.setOptions = this.setOptions.bind(this);
        this.event = true;
        this.state = {
            idForm: null,
            formSelected: null,
            selectInternalSubscriptions: '',
            optionsForm: [],
            url: '/submits/internos/',
            data: null,
            camposFiltrando: '',
            dataSearched: false,
            activeLoader: true,
        }
    }

    formatData(resData){
        let content = [];
        resData.content.forEach(item => {
            let id = item.id;
            let nome = item.nome;
            let cpf = item.cpf;
            let dataSubmissao = item.dataSubmissao;
            let statusPagamento = item.statusPagamento;
            let dadosForm = item.dadosForm;
            let valorBoleto = item.valorBoleto;
            let form = {}
            content.push({id, nome, cpf, dataSubmissao, valorBoleto, statusPagamento, dadosForm, form});
        });
        resData.content = content;
        return resData;
    }

    onPaginator = (url) => {
        this.getSubscriptions(url+this.state.idForm)
    }

    onFilter = (camposFiltrando) => {
        const url = this.state.url + this.state.idForm + '?size=10' + camposFiltrando
        this.setState({camposFiltrando});
        this.getSubscriptions(url, true);
    };

    componentDidMount(){
        buscarTodosFormulariosComInscricaoPorCpf(res => {
            let options = this.setOptions(res.data)
            this.setState({optionsForm: options})
            this.selectInternalSubscriptionByQueryParam()
        }, error => {
            this.notifyError("Erro ao carregar formulários", "");
        });
    }

    setOptions(data){
        let options = [];
        data.forEach(element => {
            let formEditavel = JSON.parse(element.formEditavel)
            options.push({key: element.id, value: formEditavel.titulo, text: formEditavel.titulo, form: element})
        });
        return options
    }

    handleChange(e, { name, value }){
        this.setState({ [name]: value, idForm: this.getIdForm(value), dataSearched: false, formSelected: this.getForm(value) })
    }

    getIdForm(value){
        let idForm
        this.state.optionsForm.map(item => {
            if(item.value === value){
                idForm = item.key
            }
        })
        return idForm;
    }

    getValue(id){
        let value
        this.state.optionsForm.map(item => {
            if(item.key == id){
                value = item.value
            }
        })
        return value;
    }

    getForm(value){
        let form
        this.state.optionsForm.map(item => {
            if(item.value === value){
                form = item.form
            }
        })
        return form;
    }

    getData(cpf){
        let itemData;
        this.state.data.content.map(item => {
            if(item.cpf === cpf){
                itemData = item;  
            }
        })
        return itemData;
    }

    selectInternalSubscriptionByQueryParam(){
        let id = this.props.location.query.idForm
        let value = this.getValue(id)
        if(id){
            this.setState({ selectInternalSubscriptions: value, idForm: id, dataSearched: false, formSelected: this.getForm(value) })
        }
    }

    getSubscriptions = (url, filtrando = false) => {
        buscarForms(url, res => {
            if(filtrando && res.data.numberOfElements === 0){
                this.setState({camposFiltrando: '', dataSearched: true})
                this.noResultOnFilter();
                return;
            }
            const resData = this.formatData(res.data);
            this.setState({ data: resData,
                activeLoader: false, dataSearched: true});
            if(this.props.location.query.cpf && this.event){
                this.event = false;
                this.showDetails(this.event, this.getData(this.props.location.query.cpf))
            }
        }, error => {
            this.setState({activeLoader: false, dataSearched: true});
            this.notifyError("Erro ao carregar formulários", "");
        });
    }

    getHomologacao(item){
        return !(item.valorBoleto !== 0 && item.statusPagamento === false)
    }

    showDetails(e, data){
        //e.preventDefault();
        this.displayModal(  'Detalhes da inscrição',
            'Detalhes da inscrição realizada por '+data.nome+' no dia '+formatLongToDate(data.dataSubmissao),
            this.contentModal(data));
    }

    contentModal(submissao){
        const key = submissao.id;
        submissao.form = this.state.formSelected
        return this.renderSubscriptionView(key, submissao)
    }

    renderSubscriptionView(key, submissao){
        return (
            <div>
                <SubscriptionView
                    submissao={submissao}
                    pesquisa_submissao={false}
                    tem_presenca={this.state.tem_presenca}
                    key={key}
                />
            </div>
        )
    }

    dataMapper = (data) => {
        return (
            <tr key={data.id}>
                <TableColumn width="20" headers="nome" content={data.nome} label="Nome" filter={{atributo: 'nome', coluna: 'Nome', tipo: 'String'}}/>
                <TableColumn width="15" headers="cpf" content={data.cpf} label="CPF" filter={{atributo: 'cpf', coluna: 'CPF', tipo: 'String', mascara:'000.000.000-00'}}/>
                <TableColumn width="5" headers="dataSubmissao" content={formatLongToDate(data.dataSubmissao)} label="Data da inscrição" filter={{atributo: 'dataSubmissao', coluna: 'Data da inscrição', tipo: 'Date'}}/>
                <TableColumn width="5" headers="status" content={this.getHomologacao(data)} label="Confirmação da inscrição" status filter={{atributo: 'status', coluna: 'Confirmação da inscrição', tipo: 'Boolean'}}/>
                <TableColumn width="10" headers="acoes" action>
                    <LinkAction icone="more" type="table" onClick={(e) => this.showDetails(e, data)} tooltip="Detalhar"/>
                </TableColumn>
            </tr>
        );
    }

    getTable(){
        if(this.state.idForm){
            if(!this.state.dataSearched){
                this.getSubscriptions(this.state.url+this.state.idForm+ '?size=10');
            }
            return(
                <Table title="Inscrições"
                    summary="Listagem das incrições"
                    url={this.state.url}
                    data={this.state.data}
                    dataMapper={this.dataMapper}
                    onFilter={this.onFilter}
                    onPaginator={this.onPaginator}//noPadding
                />
            )
        }
    }

    render() {
        return (
            <Card>
                <SelectField
                    name='selectInternalSubscriptions'
                    value={this.state.selectInternalSubscriptions}
                    options={this.state.optionsForm}
                    label='Selecione um formulário para ver as inscrições'
                    invalidMessage="Selecione uma formulário"
                    onChange={this.handleChange.bind(this)} 
                    required 
                />
                {this.getTable()}
            </Card>
        )
    }
}



// WEBPACK FOOTER //
// ./src/view/internal_forms/ListInternalSubscriptions.js